export function parcentFromPos(x, y, lightBottom, rightTop, xIsLog = false,yIsLog = false) {
  const xConverter = xIsLog ? Math.log10 : (x)=>x
  const yConverter = yIsLog ? Math.log10 : (x)=>x
  const minx = xConverter(lightBottom.x);
  const maxx = xConverter(rightTop.x);
  const miny = yConverter(rightTop.y);
  const maxy = yConverter(lightBottom.y);
  const xParcent = (xConverter(x) - minx) / (maxx - minx);
  const yParcent = (yConverter(y) - miny) / (maxy - miny);

  return { x: xParcent, y: yParcent };
}

export function pxFromParcent(width, height, parcent, scaleSpace) {
  return { x: width * parcent.x+scaleSpace, y: height * parcent.y };
}
